const base64UrlEncode = (str) => btoa(str)
    // makes it url-safe
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
export default base64UrlEncode;
//# sourceMappingURL=index.js.map